const degrees = [
  'Bachelors of Technology',
  'Masters of Technology',
  'Bachelors of Commerce',
  'Masters of Commerce',
  'Bachelors of Arts',
  'Masters of Arts',
  'Bachelors of Engineering',
  'Masters of Engineering',
  'Bachelors of Business Administration',
  'Masters of Business Administration',
  'Bachelors of Computer Applications',
  'Masters of Computer Applications',
  'Bachelors of Science',
  'Masters of Science',
  'Under Graduate Diploma',
  'Post Graduate Diploma',
];

export const bachelorDegrees = [
  'Bachelors of Technology',
  'Bachelors of Commerce',
  'Bachelors of Arts',
  'Bachelors of Engineering',
  'Bachelors of Business Administration',
  'Bachelors of Computer Applications',
  'Bachelors of Science',
  'Under Graduate Diploma',
  'OTHERS'
];

export const masterDegrees = [
  'Masters of Technology',
  'Masters of Commerce',
  'Masters of Arts',
  'Masters of Engineering',
  'Masters of Business Administration',
  'Masters of Computer Applications',
  'Masters of Science',
  'Post Graduate Diploma',
];


export default degrees;




// WEBPACK FOOTER //
// ./src/utils/degrees.js